import { amplifyProxy, directApi } from '@/services/directApi'

export default {
  namespaced: true,
  state: {
    accounts: '',
    records: '',
    loading: {
      accounts: false,
      records: false,
      export: false
    },
    error: {
      accounts: null,
      records: null,
      export: null
    }
  },
  mutations: {
    SET_ACCOUNTS(state, data) {
      state.accounts = data
    },
    SET_RECORDS(state, data) {
      state.records = data
    },
    CLEAR_RECORDS(state) {
      state.records = ''
    },
    SET_LOADING(state, { type, value }) {
      state.loading[type] = value
    },
    SET_ERROR(state, { type, error }) {
      state.error[type] = error
    }
  },
  actions: {
    async getAccounts({ commit, rootState }, payload) {
      commit('SET_LOADING', { type: 'accounts', value: true })
      commit('SET_ERROR', { type: 'accounts', error: null })
      
      try {
        const endpoint = `/${rootState.user.ClientName}/reporting/depositsheld/accounts`
        const options = {
          headers: {
            token: rootState.user.LoginToken,

          },
          queryStringParameters: {
            branchID: rootState.branchID,
            searchDate: payload
          }
        }

        const response = await amplifyProxy.get(endpoint, options)
        commit('SET_ACCOUNTS', response.data)
        return response.data
      } catch (error) {
        commit('SET_ERROR', { type: 'accounts', error: error.message })
        throw error
      } finally {
        commit('SET_LOADING', { type: 'accounts', value: false })
      }
    },

    async getRecords({ commit, rootState }, payload) {
      commit('SET_LOADING', { type: 'records', value: true })
      commit('SET_ERROR', { type: 'records', error: null })
      
      try {
        const endpoint = `/${rootState.user.ClientName}/reporting/depositsheld/${payload.scheme}/records`
        const options = {
          headers: {
            token: rootState.user.LoginToken,

          },
          queryStringParameters: {
            branchID: rootState.branchID,
            searchDate: payload.searchDate
          }
        }

        const response = await amplifyProxy.get(endpoint, options)
        commit('SET_RECORDS', response.data)
        return response.data
      } catch (error) {
        commit('SET_ERROR', { type: 'records', error: error.message })
        throw error
      } finally {
        commit('SET_LOADING', { type: 'records', value: false })
      }
    },

    async exportRecords({ commit, rootState }, payload) {
      commit('SET_LOADING', { type: 'export', value: true })
      commit('SET_ERROR', { type: 'export', error: null })

      try {
        const endpoint = `/${rootState.user.ClientName}/reporting/depositsheld/${payload.scheme}/records/export`
        const queryParams = {
          branchID: rootState.branchID,
          searchDate: payload.searchDate
        }

        await directApi.exportCsv(
          rootState.user.ClientName,
          endpoint,
          queryParams,
          'depositsHeldExport.CSV',
          rootState.user.LoginToken
        )

        return { success: true }
      } catch (error) {
        commit('SET_ERROR', { type: 'export', error: error.message })
        throw error
      } finally {
        commit('SET_LOADING', { type: 'export', value: false })
      }
    }
  }
}